import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import { RotateCcw, CalendarClock, User2, Music2, MessageSquare, Type, Shuffle } from "lucide-react";
import { HOME } from "../constants/testIds";

export const MetadataEditor = ({ meta, setMeta, defaults, onReset, onRandom }) => {
  const upd = (k, v) => setMeta((prev) => ({ ...prev, [k]: v }));

  const field = (icon, label, value, onChange, testId, placeholder, type = "text") => (
    <div className="space-y-2">
      <Label className="flex items-center gap-2 text-xs uppercase tracking-widest text-zinc-500 font-semibold">
        {icon}
        {label}
      </Label>
      {type === "textarea" ? (
        <Textarea
          data-testid={testId}
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          rows={3}
          className="bg-[#0a0a0b] border-white/10 focus-visible:ring-1 focus-visible:ring-pink-600/60 focus-visible:border-pink-600/50 text-zinc-100 placeholder:text-zinc-600 resize-none"
        />
      ) : (
        <Input
          data-testid={testId}
          type={type}
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className="bg-[#0a0a0b] border-white/10 focus-visible:ring-1 focus-visible:ring-pink-600/60 focus-visible:border-pink-600/50 text-zinc-100 placeholder:text-zinc-600 h-11"
        />
      )}
    </div>
  );

  return (
    <div className="mt-6">
      <div className="flex items-center justify-between mb-5">
        <h3 className="font-heading text-lg font-bold tracking-tight">
          Мета-данные
        </h3>
        <div className="flex items-center gap-2">
          <button
            data-testid="randomize-meta"
            onClick={onRandom}
            className="inline-flex items-center gap-2 text-xs font-semibold text-white ig-gradient rounded-full px-3.5 py-1.5 hover:scale-[1.03] active:scale-[0.97] transition-transform duration-200 shadow-[0_6px_18px_-6px_rgba(220,39,67,0.7)]"
          >
            <Shuffle className="w-3.5 h-3.5" />
            Рандом
          </button>
          <button
            data-testid={HOME.resetMeta}
            onClick={onReset}
            className="inline-flex items-center gap-2 text-xs text-zinc-400 hover:text-white border border-white/10 hover:border-white/25 rounded-full px-3 py-1.5 transition-colors duration-200"
          >
            <RotateCcw className="w-3 h-3" />
            Сброс
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {field(<Type className="w-3 h-3" />, "Название", meta.title, (v) => upd("title", v), HOME.metaTitle, defaults?.title || "")}
        {field(<User2 className="w-3 h-3" />, "Автор", meta.artist, (v) => upd("artist", v), HOME.metaArtist, defaults?.artist || "@username")}
        {field(<Music2 className="w-3 h-3" />, "Альбом", meta.album, (v) => upd("album", v), HOME.metaAlbum, "Instagram")}
        {field(<CalendarClock className="w-3 h-3" />, "Дата и время создания", meta.creation_time, (v) => upd("creation_time", v), HOME.metaCreationTime, "", "datetime-local")}
        <div className="md:col-span-2">
          {field(<MessageSquare className="w-3 h-3" />, "Комментарий", meta.comment, (v) => upd("comment", v), HOME.metaComment, "Заметка...", "textarea")}
        </div>
      </div>
    </div>
  );
};
